<template>
    <form class="form-inline" @submit.prevent="onSearchSubmit">
        <div class="row mb-10">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="nombres">Nombres</label>
                    <input type="text" class="form-control" id="nombres" v-model="nombres">
                </div>
                <div class="form-group">
                    <label for="apellidos">Apellidos</label>
                    <input type="text" class="form-control" id="apellidos" v-model="apellidos">
                </div>
                <div class="form-group">
                    <label for="anio">Año</label>
                    <input type="number" min="2018" max="2022" class="form-control" id="anio" v-model="anio">
                </div>
            </div>
        </div>

        <div class="row mb-10">
            <div class="col-md-12">
                <label>Sexo</label>
                <!-- Sexo -->
                <label class="checkbox-inline" v-for="sex in sex_types" :key="sex.id">
                    <input type="checkbox" :id="'inlineCheckboxSexo'+sex.id" name="sexo" :value="sex.id" v-model="sexo"> {{ sex.valor }}
                </label>        

                <label>Estatus Actual</label>
                <!-- Estatus Actual -->
                <label class="checkbox-inline" v-for="status in status_types" :key="status.id">
                    <input type="checkbox" :id="'inlineCheckboxEstatus'+status.id" name="estatus_actual" :value="status.id" v-model="estatus_actual"> {{ status.valor }}
                </label>
            </div>
        </div>

        <button type="submit" class="btn btn-primary">Buscar</button>
    </form>
</template>

<script>
export default {
  name: 'SearchForm',
  props: {
    sex_types: Object,
    status_types: Object
  },
  data() {
      return {
          nombres: '',
          apellidos: '',
          anio: 2018,
          sexo: [],
          estatus_actual: []
      }
  },
  emits: ['searchSubmit'],
  methods: {
      onSearchSubmit() {
          let formData = {
              nombres: this.nombres,
              apellidos: this.apellidos,
              anio: this.anio,
              sexo: JSON.parse(JSON.stringify(this.sexo)),
              estatus_actual: JSON.parse(JSON.stringify(this.estatus_actual))
          }
          this.$emit('searchSubmit', formData);
      }
  }
}
</script>

<style scoped>
.form-inline {
    display: block;
}
.form-inline .row {
    width: 100%;
}
.form-inline .form-group {
  display: inline-block;
  margin-bottom: 0;
  vertical-align: middle;
}
.form-inline label {
    display: inline-block;
    margin-right: 10px;
}
.form-inline .form-control {
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
.form-group + .form-group {
    margin-left: 15px;
}
.checkbox-inline, 
.radio-inline {
    position: relative;
    display: inline-block;
    padding-left: 20px;
    margin-bottom: 0;
    font-weight: 400;
    vertical-align: middle;
    cursor: pointer;
    max-width: 100%;
}
input[type="checkbox"], input[type="radio"] {
    margin: 4px 0 0;
    margin-left: 0px;
    /* margin-top: 1px\9; */
    line-height: normal;
    box-sizing: border-box;
    padding: 0;
}
.checkbox input[type="checkbox"], .checkbox-inline input[type="checkbox"], .radio input[type="radio"], .radio-inline input[type="radio"] {
    position: absolute;
    margin-top: 1px;
    margin-left: -20px;
    width: auto;
}
.btn-default {
    border: 1px solid gray;
    border-radius: 0px;
}
button + button {
    margin-left: 15px;
}
</style>